import { Vehicle } from '../../../API/types/Vehicles';

export const generatePreviewFullName = (
  firstName: string | undefined,
  surname: string | undefined,
): string => {
  if (!!firstName && !!surname) {
    return `${firstName} ${surname}`;
  }

  return 'Add driver name';
};

export const generatePreviewLicense = (license: string | undefined): string => {
  if (license?.length) {
    return license;
  }

  return 'Add license';
};

export const generateLicenseExpiration = (expirationDate: string | undefined): string => {
  if (expirationDate?.length) {
    return expirationDate;
  }

  return 'Add license expiration date';
};

export const generateUnassignedVehiclesTitle = (vehicles: Vehicle[] | undefined): string => {
  if (!vehicles?.length) {
    return 'Vehicles';
  }
  const isPlural = vehicles.length === 1;
  return `${vehicles.length} unassigned ${isPlural ? 'vehicle' : 'vehicles'}`;
};
